var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 8.25a8.25 8.25 0 0 1-9.789 8.106l-1.125 1.266c-.214.24-.52.378-.841.378H10.5v1.875c0 .621-.504 1.125-1.125 1.125H7.5v1.875C7.5 23.496 6.996 24 6.375 24h-5.25A1.125 1.125 0 0 1 0 22.875v-3.659c0-.298.119-.585.33-.796l7.584-7.584A8.25 8.25 0 0 1 15.75 0C20.32 0 24 3.68 24 8.25zM15.75 6a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0z",
    id: "ss5yc4jr2a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uijwwtlmkb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ss5yc4jr2a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#ss5yc4jr2a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#uijwwtlmkb)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidKey);
export default __webpack_public_path__ + "static/media/solid-key.51c2a7c3f5e9e7eaa2e18581dfb335d6.svg";
export { ForwardRef as ReactComponent };